export default async function (promise) {
    const res = await promise;
    return res.status === 200 ? res.json() : false;
}
